import React, { memo, useState, useCallback, useRef, useEffect, Component } from 'react';
import {setContextualHelp} from "actions/index.js";
import Colors from 'components/Colors.js';
import {setParameterSliderDown} from "actions/index.js";
import {updateParameter} from 'operations/actions.js';
import { connect } from "react-redux";
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import { Text, Circle, Group, Stage, Layer, Rect, Line} from 'react-konva';
import {OPERATOR_HARMONICITY_MODULATION} from 'constants/contextual-help.js';

const MOD_MAX = 15;
const colors = new Colors();

window.fmColor = '#0c3545';
window.fmGuideColor = '#66d6ff';
window.selectedFMColor = '#46aaff';

const WIDTH=242;
const HEIGHT=140;
const INNER_HEIGHT= 136;

const FMHarmonicityModulation = memo((props) => {

    let groupRef = useRef(undefined);
    let innerHeight = props.innerHeight || INNER_HEIGHT;
    let height = props.height || HEIGHT;

    const setDraggingOsc = (osc) => {
        props.setDraggingOsc(osc);
        if (osc) {
            props.setParameterSliderDown([
                props.osc.harmonicityParameter,
                props.osc.modulationIndexParameter
           ]);
        } else {
            props.setParameterSliderDown([]);
            if (props.osc.harmonicityParameter.automation.isRecording) {
                props.osc.harmonicityParameter.automation.smoothen();
                props.osc.modulationIndexParameter.automation.smoothen();
            }
        }
    };

    const updateParameter = (parameter, value) => {
        props.sequencerEngine.operationManager.dispatch(
            updateParameter(
                parameter,
                value));
    };

    const setHarmonicity = (h) => {
        let osc = props.oscillator;
        if (osc) {
            updateParameter(
                props.oscillator.harmonicityParameter,
                h);
        }
    };

    const setModulationIndex = (m) => {
        if (props.oscillator) {
            updateParameter(
                props.oscillator.modulationIndexParameter,
                m);
        }
    };

    const getHarmonicityXPosition = (harmonicity) => {
        return (harmonicity / 20) * WIDTH;
    };

    const getHarmonicityX = useCallback((osc) => {
        return getHarmonicityXPosition(props.harmonicity);
    }, [props.harmonicity]);

    const getModulationIndexYPosition = (modulationIndex) => {
        return innerHeight - ((Math.sqrt(modulationIndex) / MOD_MAX) * innerHeight);
    };

    const getModulationIndexY = useCallback((osc) => {
        return getModulationIndexYPosition(props.modulation);
    }, [props.modulation]);

    const getHelperLines = useCallback(() => {
        let osc = props.oscillator;
        if (props.oscillator !== props.osc) {
            return [];
        }
        return [
       ];
    }, [props.harmonicity, props.modulation, props.osc, props.oscillator]);

    let selectedOsc = props.oscillator;
    let oscs = props.instrument.oscillators;
    if (oscs === undefined) {
        return [];
    }
    
    let osc = props.osc;
    let x = getHarmonicityX(osc);
    let y = getModulationIndexY(osc);

    useEffect(() => {
        groupRef.current.setAttribute(
            'transform', `translate(${x}, ${y})`);
    }, [x,y]);

    return (
        <g ref={groupRef}>
          <Anim selected={selectedOsc === osc} osc={osc} height={height} color={props.color} setDraggingOsc={setDraggingOsc}/>
       </g>
        );
});

const Anim = memo(({osc, setDraggingOsc, color, height, selected}) => {
    return [
        selected ? <line
          key={1}
                     x1={0} y1={-height} x2={0} y2={height} strokeWidth={1} stroke={window.fmGuideColor}/> : '',
        selected ? <line
          key={2}
          x1={-WIDTH} y1={0} x2={WIDTH}
                     y2={0} strokeWidth={1} stroke={window.fmGuideColor}/> : '',
         <circle
           key={3}
           onMouseDown={(e) => setDraggingOsc(osc)}
           onMouseUp={(e) => {
               setDraggingOsc(undefined);
           }}
           cx={0}
           cy={0}
           r={8}
           fill={color}
           strokeWidth={1} />,
        <text
          key={4}
          onMouseDown={(e) => setDraggingOsc(osc)}
          onMouseUp={(e) => {
              setDraggingOsc(undefined);
          }}
          fontSize={10}
          fontFamily='Arial'
          x={osc.name.length === 1 ? -3 :-6}
          
          y={4}
        >{osc.name}</text>
    ];
});


const mapStateToProps = (state, props) => {
    if (props.instrument.oscillators === undefined) {
        return {
        };
    }
    
    let params = state.effects.effectParameters;
    let harmonicity = params[props.osc.harmonicityParameter.id]; 
    let modulation = params[props.osc.modulationIndexParameter.id]; 
    return {
        // connectedOscs: props.instrument.connectedOscillators
        harmonicity,
        modulation
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setParameterSliderDown: parameter => dispatch(setParameterSliderDown(parameter)),
        setContextualHelp: (element, arg) => dispatch(setContextualHelp(element, arg))
    }
};
 

export default connect(mapStateToProps, mapDispatchToProps)(FMHarmonicityModulation);

